<div class="flex h-screen bg-[#15181D] xl:pr-1.5 overflow-x-hidden">
  <!-- Sidebar -->
  <app-sidebar
    [collapsed]="sidebarCollapsed()"
    [isMobile]="isMobile()"
    [sidebarOpen]="mobileSidebarOpen()"
    (toggleSidebar)="onSidebarToggle($event)"
    (mobileSidebarClose)="onMobileSidebarClose()"
    (activeMenuTitle)="onActiveMenuTitleChange($event)"
    #sidebarRef
  >
  </app-sidebar>

  <!-- Main Content Area -->
  <div class="flex-1 flex flex-col overflow-hidden w-0 min-w-0">
    <!-- Sticky Header -->
    <div class="sticky top-0 xl:top-2 z-30">
      <app-header
        [sidebarCollapsed]="sidebarCollapsed()"
        (toggleSidebar)="toggleSidebar()"
        #headerRef
      >
      </app-header>
    </div>

    <!-- Main Content -->
    <main class="flex-1 overflow-auto bg-[#FCFCFC]  px-4 pb-4 pt-3 h-full md:p-5  overflow-x-hidden">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<!-- Global Loader Overlay -->
<app-loader [show]="loading()" [message]="loaderMessage()" />

